let $ = jQuery;
let SubmitByIcon = require('./submit-by-icon');

class FormFilter {

  constructor(context) {
    if (context !== document) {
      return;
    }

    this.enableTrigger();
    this.enableOnchange();
    this.filterByIcon = new SubmitByIcon('filter-by', $('#edit-filter-by'), $('.dashboard__filter-form__filters'));
    this.filterByIcon = new SubmitByIcon('search-for', $('#edit-search-for'), $('.dashboard__filter-form__search'));
  }

  enableOnchange() {
    var self = this;
    $(".dashboard__filter-form__filters select.form-select").change(function() {
      self.updateDropDownDisplayText();
    });
  }

  enableTrigger() {
    $('.dashboard__filter-form__trigger').bind('click', function() {
      $(this).toggleClass('dashboard__filter-form__trigger--open');
      $('.filter-form').toggleClass('filter-form--open');
      $('.dashboard__filter-form__clear-all').toggle();

    });

    $('.dashboard__filter-form__clear-all').bind('click', function() {
      window.location.href = window.location.pathname;
    });
  }

  updateDropDownDisplayText() {
    var $interest_default = $("#edit-interest option:first-child");
    if (!$interest_default.is(":selected")) {
      $interest_default.html('All');
    }
    else {
      $interest_default.html('Interest');
    }

    var $bundle_default = $("#edit-bundle option:first-child");
    if (!$bundle_default.is(":selected")) {
      $bundle_default.html('All');
    }
    else {
      $bundle_default.html('Type');
    }

    var $sort_default = $("#edit-sort option:first-child");
    if (!$sort_default.is(":selected")) {
      $sort_default.html('Newest');
    }
    else {
      $sort_default.html('Sort By');
    }
  }

}

module.exports = {
  attach: function (context, settings) {
    let formFilter = new FormFilter(context);
  }
};
